var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRightArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    rx: 3,
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.518 15.2148C18.7641 14.9688 18.7641 14.5586 18.518 14.3125L13.2133 8.98047C12.9398 8.73438 12.5297 8.73438 12.2836 8.98047L11.6547 9.60938C11.4086 9.85547 11.4086 10.2656 11.6547 10.5391L15.8656 14.75L11.6547 18.9883C11.4086 19.2617 11.4086 19.6719 11.6547 19.918L12.2836 20.5469C12.5297 20.793 12.9398 20.793 13.2133 20.5469L18.518 15.2148Z",
    fill: "black",
    fillOpacity: 0.3
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrow);
export default __webpack_public_path__ + "static/media/right-arrow.c02ad1753984ad02ee6fa594176ad8b6.svg";
export { ForwardRef as ReactComponent };